<template>
    <div>
        <h1>Sessions</h1>

        <div v-if="loadingDifficulties">
            Loading difficulties..
        </div>
        <div v-else>
            <h2>Difficulties</h2>

            <div class="mb-3 row">
                <button-radio-container
                        v-model="currentDifficultyLevel"
                        :options="difficultyLevels"
                        class="btn-group"
                        type="secondary" />

                <button-radio-container
                        v-if="currentDifficultyLevel"
                        v-model="currentDifficulty"
                        :options="difficulties"
                        class="ml-3 btn-group"
                        type="secondary" />
            </div>

            <div v-if="loadingSessions">
                Loading sessions..
            </div>
            <div v-else-if="difficultySessions.length">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Session</th>
                            <th>Line</th>
                            <th>Scenarios</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="difficultySession in difficultySessions">
                            <td>{{ difficultySession.dataId || 'TUTORIAL' }}</td>
                            <td>{{ difficultySession.line }}</td>
                            <td>{{ difficultySession.scenarioCount }}</td>
                            <td><router-link class="btn btn-primary btn-sm" :to="'/admin/sessions/update/' + difficultySession.id">View</router-link></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import ButtonRadioContainer from "@/components/common/ButtonRadioContainer";

    export default {
        name: 'sessions-index',
        components: {ButtonRadioContainer},
        data() {
            return {
                // Hardcoded data
                difficultyLevels: {
                    L1: 'L1',
                    L2: 'L2',
                    //L3: 'L3',
                },
                difficulties: {
                    easy: 'easy',
                    //medium: 'medium',
                    hard: 'hard'
                },

                // Loading data
                loadingDifficulties: true,
                loadingSessions: false,

                // Cached data
                difficultyIds: {},
                difficultySessions: [],

                // Current selections
                currentDifficultyLevel: null,
                currentDifficulty: null,
            }
        },
        mounted() {
            this.$apiClient.getDifficulties().then((difficulties) => {
                this.difficultyIds = {};

                for (let difficulty of difficulties) {
                    let difficultyId = difficulty.id;
                    let difficultyKey = difficulty.level + '.' + difficulty.difficulty;

                    this.difficultyIds[difficultyKey] = difficultyId;
                }

                this.loadingDifficulties = false;

                if (this.currentDifficultyLevel && this.currentDifficulty) {
                    this.doReload();
                }
            });

            if (this.$router.currentRoute.query.difficultyLevel) {
                this.currentDifficultyLevel = this.$router.currentRoute.query.difficultyLevel;
            }

            if (this.$router.currentRoute.query.difficulty) {
                this.currentDifficulty = this.$router.currentRoute.query.difficulty;
            }
        },
        computed: {
            difficultyId() {
                if (!this.currentDifficultyLevel) {
                    return null;
                }

                if (!this.currentDifficulty) {
                    return null;
                }

                let difficultyKey = this.currentDifficultyLevel + '.' + this.currentDifficulty;

                if (!this.difficultyIds.hasOwnProperty(difficultyKey)) {
                    return null;
                }

                return this.difficultyIds[difficultyKey];
            },
        },
        methods: {
            doReload() {
                this.$router.push({query: {
                    difficultyLevel: this.currentDifficultyLevel,
                    difficulty: this.currentDifficulty
                }});

                if (!this.difficultyId) {
                    return;
                }

                this.difficultySessions = [];
                this.loadingSessions = true;

                this.$apiClient.getSessionsByDifficultyId(this.difficultyId).then((data) => {
                    this.difficultySessions = data;
                    this.loadingSessions = false;
                });
            }
        },
        watch: {
            currentDifficultyLevel(difficultyLevel) {
                this.doReload();
            },
            currentDifficulty(difficulty) {
                this.doReload();
            }
        }
    }
</script>

<style scoped lang="scss">
</style>
